var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasResults || _vm.Screen == "SRCH"
    ? _c(
        "div",
        { staticClass: "g-searchspring__container" },
        [
          _c("cart-toast", { attrs: { results: _vm.searchData.results } }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "g-searchspring__header" },
            [
              _c("banner", {
                attrs: {
                  merchandising: _vm.searchData.merchandising,
                  type: "header",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "g-searchspring__content g-layout g-layout--justify-center",
            },
            [
              _vm.hasResults
                ? _c(
                    "div",
                    {
                      staticClass:
                        "g-searchspring__div g-layout__item u-width-12 u-width-3--l",
                      attrs: { id: "js-searchsrping-facets" },
                    },
                    [
                      _c("facets", {
                        attrs: {
                          breadcrumbs: _vm.searchData.breadcrumbs,
                          facets: _vm.searchData.facets,
                          filterSummary: _vm.searchData.filterSummary,
                          pagination: _vm.searchData.pagination,
                        },
                      }),
                      _vm._v(" "),
                      _c("banner", {
                        attrs: {
                          merchandising: _vm.searchData.merchandising,
                          type: "left",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "g-searchspring__results g-layout__item u-width-12 u-width-9--l",
                },
                [
                  _c("search-results", {
                    attrs: {
                      facets: _vm.searchData.facets,
                      filterSummary: _vm.searchData.filterSummary,
                      merchandising: _vm.searchData.merchandising,
                      pagination: _vm.searchData.pagination,
                      results: _vm.searchData.results,
                      sorting: _vm.searchData.sorting,
                      didYouMean: _vm.searchData.didYouMean,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "g-searchspring__footer" },
            [
              _c("banner", {
                attrs: {
                  merchandising: _vm.searchData.merchandising,
                  type: "footer",
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }